import React from "react";

export interface GlobalStoreContextType {
    storeKeyName: string;
    set: (key: string, value: string) => void;
    get: (key: string) => string | undefined;
    delete: (key: string) => void;
    deleteAll: () => void;
}

const GlobalStoreContext = React.createContext<GlobalStoreContextType>({
    storeKeyName: "web-cart-global-store",
    set: (_key: string, _value: string) => void 0,
    get: (_key: string) => undefined,
    delete: (_key: string) => void 0,
    deleteAll: () => void 0,
});

export default GlobalStoreContext;
